import React from 'react';
import { Delivery } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import './RiderDetails.scss';

const dashboardMode = window.dashboard.mode;

function getLanguages(languages) {
  if (!languages && languages && !languages.length) return null;
  let allLanguages = '';
  if (languages.PRIMARY) {
    allLanguages = languages.PRIMARY.join(',');
    if (languages.SECONDARY) {
      allLanguages = languages.PRIMARY.concat(languages.SECONDARY).join(', ');
    }
  }
  return allLanguages;
}

export const RiderDetails = ({ valet, riderDetails }) => {
  if (!valet) return '';
  return (
    <div className={`riderDetails tooltip ${dashboardMode}`}>
      <div className='info col'>
        {riderDetails && riderDetails.rider_name ? (
          <h3 className='tooltipHeading' data-dd-privacy='mask'>
            {riderDetails.rider_name || ''}
          </h3>
        ) : null}
        <h3 className='tooltipHeading' data-dd-privacy='mask'>
          {(riderDetails && riderDetails.header_text) || 'Rider Details'}
        </h3>
        <div className='tooltipContent'>
          <p className='riderType'>
            <span className='iconMarginR'>
              <Delivery size={14} color={grey.z500} />
            </span>
            <span>{valet.carrier_type} Rider</span>
          </p>
          <p
            className='riderLanguages marginBottom pt10'
            data-dd-privacy='mask'
          >
            {getLanguages(valet.language_preferences)}
          </p>
          {riderDetails &&
            riderDetails.rider_performance &&
            riderDetails.rider_performance.map((item, index) => (
              <p className={item.color} key={index} data-dd-privacy='mask'>
                {item.text}
              </p>
            ))}
        </div>
      </div>
      {riderDetails && riderDetails.bottom_text ? (
        <p className='karmaSection mt10' data-dd-privacy='mask'>
          {riderDetails.bottom_text}
        </p>
      ) : null}
    </div>
  );
};
